export default __webpack_public_path__ + "static/media/USD.d1188f10.svg";